import React from 'react';

import styled from 'styled-components';

import at from './assets/icons/at.svg';
import bits from './assets/icons/bits.svg';

const App = () => (
  <Container>
    <Logo>أبجد</Logo>

    <Desc>
      <Bits />

      <Ar>معامل برمجيات. نصمم ونطوّر تجارب رقمية إبداعية.</Ar>

      <En>
        Software labs. We design and develop digital creative experiences.
      </En>

      <Email>hello@abcd.sa</Email>
    </Desc>
  </Container>
);

const Full = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Container = Full.withComponent('main').extend`
  @media (min-width: 768px) {
    flex-direction: row;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const Landing = Full.extend`
  align-items: center;
  justify-content: center;
`;

const Logo = Landing.extend`
  color: #ff3066;
  font-family: 'Aref Ruqaa', serif;
  font-size: 72px;
`;

const Desc = Landing.extend`
  background-color: #ff3066;
  color: #ffffff;
  font-family: 'Amiri', serif;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
`;

const Img = styled.img`
  height: ${props => props.size}px;
  width: ${props => props.size}px;
`;

const Bits = Img.extend.attrs({ alt: '', src: bits, size: 24 })`
  margin-top: 20px;
`;

const Ar = styled.div`
  margin-top: 40px;
`;

const En = styled.div`
  direction: ltr;
  font-family: 'Open Sans', sans-serif;
  margin-bottom: 40px;
  margin-top: 20px;
`;

const Email = ({ children }) => (
  <EmailLink href={`mailto:${children}`}>
    <Img alt={children} src={at} size={32} />
  </EmailLink>
);

const EmailLink = styled.a`
  color: #ffffff;
  transition: all 0.2s ease 0s;

  &:hover {
    transform: scale(1.1);
  }
`;

export default App;



// WEBPACK FOOTER //
// ./src/App.js